import { useMemo, useState } from "react";
import { addDays, startOfDay } from "date-fns";
import { getWeekDates, shiftWeek } from "../utils/weekUtils";

type WeekWhereItem = {
  field: string;
  operator: ">=" | "<";
  value: Date;
};

export const useWeekNavigation = (initialDate: Date = new Date()) => {
  const [currentWeek, setCurrentWeek] = useState(initialDate);

  const weekDates = useMemo(() => getWeekDates(currentWeek), [currentWeek]);

  const goToPreviousWeek = () => {
    setCurrentWeek((prev) => shiftWeek(prev, -1));
  };

  const goToNextWeek = () => {
    setCurrentWeek((prev) => shiftWeek(prev, 1));
  };

  const getWeekWhere = (field?: string): WeekWhereItem[] => {
    if (!field) {
      return [];
    }

    return [
      {
        field,
        operator: ">=",
        value: startOfDay(weekDates[0]),
      },
      {
        field,
        operator: "<",
        value: startOfDay(addDays(weekDates[6], 1)),
      },
    ];
  };

  return {
    currentWeek,
    weekDates,
    goToPreviousWeek,
    goToNextWeek,
    getWeekWhere,
  };
};
